export default {
  removeArtisan({ commit }) {
    commit('REMOVE_ARTISAN')
  },
  setArtisan({ commit }, artisan) {
    commit('SET_ARTISAN', artisan)
  }
}
